var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRankings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 125,
    viewBox: "0 0 92 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8836_20107)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -90.7117,
    width: 182.288,
    height: 124.724,
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0269,
    y: 27.1826,
    width: 9.59413,
    height: 7.99511,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4133,
    y: 31.9795,
    width: 9.59413,
    height: 3.19804,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4133,
    y: 36.7764,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.22,
    y: 36.7764,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0269,
    y: 36.7764,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.22,
    y: 19.1875,
    width: 9.59413,
    height: 15.9902,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0266,
    y: 52.7686,
    width: 9.59413,
    height: 7.99511,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4131,
    y: 57.5654,
    width: 9.59413,
    height: 3.19804,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4131,
    y: 62.3623,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2197,
    y: 62.3623,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0266,
    y: 62.3623,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2197,
    y: 44.7734,
    width: 9.59413,
    height: 15.9902,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0266,
    y: 78.3525,
    width: 9.59413,
    height: 7.99511,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4131,
    y: 83.1494,
    width: 9.59413,
    height: 3.19804,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4131,
    y: 87.9463,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2197,
    y: 87.9463,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0266,
    y: 87.9463,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2197,
    y: 70.3574,
    width: 9.59413,
    height: 15.9902,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0266,
    y: 103.938,
    width: 9.59413,
    height: 7.99511,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4131,
    y: 108.734,
    width: 9.59413,
    height: 3.19804,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4131,
    y: 113.531,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2197,
    y: 113.531,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0266,
    y: 113.531,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2197,
    y: 95.9424,
    width: 9.59413,
    height: 15.9902,
    rx: 1.59902,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0027,
    y: 27.1826,
    width: 9.59413,
    height: 7.99511,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3892,
    y: 31.9795,
    width: 9.59413,
    height: 3.19804,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3892,
    y: 36.7764,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1958,
    y: 36.7764,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0027,
    y: 36.7764,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1958,
    y: 19.1875,
    width: 9.59413,
    height: 15.9902,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0024,
    y: 78.3525,
    width: 9.59413,
    height: 7.99511,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3887,
    y: 83.1494,
    width: 9.59413,
    height: 3.19804,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3887,
    y: 87.9463,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1956,
    y: 87.9463,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0024,
    y: 87.9463,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1956,
    y: 70.3574,
    width: 9.59413,
    height: 15.9902,
    rx: 1.59902,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0027,
    y: 103.938,
    width: 9.59413,
    height: 7.99511,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3889,
    y: 108.734,
    width: 9.59413,
    height: 3.19804,
    rx: 1.59902,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.3889,
    y: 113.531,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1958,
    y: 113.531,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.0027,
    y: 113.531,
    width: 9.59413,
    height: 1.59902,
    rx: 0.799511,
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.1958,
    y: 95.9424,
    width: 9.59413,
    height: 15.9902,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6327 51.5305C67.4381 51.5305 67.2522 51.4701 67.0948 51.3559L66.032 50.5838L64.9691 51.3559C64.8117 51.4701 64.6258 51.5305 64.4312 51.5305C64.2367 51.5305 64.0508 51.4701 63.8934 51.3559C63.5715 51.1221 63.4379 50.7108 63.5608 50.3328L63.9669 49.0834L62.904 48.3113C62.5821 48.0776 62.4485 47.6663 62.5717 47.2882C62.6946 46.9101 63.0444 46.656 63.4421 46.656H64.7557L65.1618 45.4066C65.2847 45.0283 65.6345 44.7744 66.0322 44.7744C66.4299 44.7744 66.7798 45.0286 66.9027 45.4066L67.3087 46.656H68.6223C69.02 46.656 69.3699 46.9101 69.4928 47.2882C69.6157 47.6663 69.4821 48.0776 69.1605 48.3113L68.0976 49.0834L68.5036 50.3328C68.6265 50.7108 68.4929 51.1221 68.1713 51.3559C68.0142 51.4701 67.828 51.5305 67.6335 51.5305H67.6327Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4124 63.9634C56.8536 63.9634 56.3989 63.5087 56.3989 62.9499V61.8632C56.3989 61.3045 56.8536 60.8498 57.4124 60.8498H58.4899V54.6796C58.4899 54.1749 58.9004 53.7644 59.4051 53.7644H63.0081V51.5333C63.0081 51.0287 63.4186 50.6182 63.9233 50.6182H68.4415C68.9461 50.6182 69.3566 51.0287 69.3566 51.5333V55.3387H72.9597C73.4643 55.3387 73.8748 55.7493 73.8748 56.2539V60.8495H74.3902C74.9489 60.8495 75.4036 61.3042 75.4036 61.863V62.9496C75.4036 63.5084 74.9489 63.9631 74.3902 63.9631H57.4124V63.9634Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6327 51.5305C67.4381 51.5305 67.2522 51.4701 67.0948 51.3559L66.032 50.5838L64.9691 51.3559C64.8117 51.4701 64.6258 51.5305 64.4312 51.5305C64.2367 51.5305 64.0508 51.4701 63.8934 51.3559C63.5715 51.1221 63.4379 50.7108 63.5608 50.3328L63.9669 49.0834L62.904 48.3113C62.5821 48.0776 62.4485 47.6663 62.5717 47.2882C62.6946 46.9101 63.0444 46.656 63.4421 46.656H64.7557L65.1618 45.4066C65.2847 45.0283 65.6345 44.7744 66.0322 44.7744C66.4299 44.7744 66.7798 45.0286 66.9027 45.4066L67.3087 46.656H68.6223C69.02 46.656 69.3699 46.9101 69.4928 47.2882C69.6157 47.6663 69.4821 48.0776 69.1605 48.3113L68.0976 49.0834L68.5036 50.3328C68.6265 50.7108 68.4929 51.1221 68.1713 51.3559C68.0142 51.4701 67.828 51.5305 67.6335 51.5305H67.6327Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4124 63.9634C56.8536 63.9634 56.3989 63.5087 56.3989 62.9499V61.8632C56.3989 61.3045 56.8536 60.8498 57.4124 60.8498H58.4899V54.6796C58.4899 54.1749 58.9004 53.7644 59.4051 53.7644H63.0081V51.5333C63.0081 51.0287 63.4186 50.6182 63.9233 50.6182H68.4415C68.9461 50.6182 69.3566 51.0287 69.3566 51.5333V55.3387H72.9597C73.4643 55.3387 73.8748 55.7493 73.8748 56.2539V60.8495H74.3902C74.9489 60.8495 75.4036 61.3042 75.4036 61.863V62.9496C75.4036 63.5084 74.9489 63.9631 74.3902 63.9631H57.4124V63.9634Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.923 54.6777H59.4048V61.7631H63.923V54.6777Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4413 51.5322H63.9231V61.7638H68.4413V51.5322Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9589 56.2539H68.4407V61.7647H72.9589V56.2539Z",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.032 45.6875L66.6433 47.5693H68.6219L67.0214 48.7323L67.6327 50.6141L66.032 49.4511L64.4313 50.6141L65.0426 48.7323L63.4421 47.5693H65.4207L66.032 45.6875Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8183 51.8584H66.3123V61.663H67.8183V51.8584Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2617 55.0303H61.7556V61.663H63.2617V55.0303Z",
    fill: "#DEE2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4467 56.5771H70.9407V61.662H72.4467V56.5771Z",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3903 61.7646H57.4123C57.358 61.7646 57.314 61.8087 57.314 61.863V62.9499C57.314 63.0042 57.358 63.0482 57.4123 63.0482H74.3903C74.4446 63.0482 74.4886 63.0042 74.4886 62.9499V61.863C74.4886 61.8087 74.4446 61.7646 74.3903 61.7646Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6357 55.1574V54.7924H66.075V53.4777L65.6465 53.6126V53.1961L66.1417 53.0371H66.5749V54.7926H67.0126V55.1576H65.6357V55.1574Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.698 58.5922V58.2364C60.7284 58.2141 60.7686 58.1838 60.8191 58.1454C60.8696 58.1069 60.926 58.0622 60.9888 58.0112C61.0513 57.9602 61.1159 57.9053 61.182 57.8468C61.2482 57.7882 61.3122 57.7267 61.3745 57.6627C61.4367 57.5986 61.4924 57.5348 61.5418 57.4718C61.5912 57.4088 61.6307 57.3468 61.66 57.2862C61.6893 57.2255 61.7039 57.169 61.7039 57.1165C61.7039 57.0639 61.6979 57.0226 61.6856 56.9863C61.6736 56.9499 61.6561 56.9204 61.6333 56.8976C61.6106 56.8749 61.5839 56.8579 61.553 56.8469C61.5222 56.8359 61.4877 56.8302 61.4492 56.8302C61.3886 56.8302 61.3355 56.8485 61.2895 56.8848C61.2435 56.9212 61.2055 56.9659 61.1757 57.0189C61.1459 57.072 61.125 57.1243 61.113 57.1758L60.6829 56.991C60.7101 56.8798 60.761 56.7839 60.8358 56.7031C60.9106 56.6223 61.0011 56.5606 61.1078 56.5174C61.2142 56.4746 61.3287 56.4531 61.4508 56.4531C61.5598 56.4531 61.6608 56.4644 61.7538 56.4871C61.8467 56.5099 61.9277 56.5467 61.997 56.5977C62.066 56.6487 62.1202 56.7162 62.1591 56.7998C62.1981 56.8838 62.2174 56.9876 62.2174 57.1118C62.2174 57.1886 62.1991 57.2676 62.163 57.3489C62.1267 57.4302 62.0789 57.5105 62.02 57.5897C61.9609 57.669 61.8974 57.7443 61.8291 57.8154C61.7609 57.8865 61.694 57.9511 61.6283 58.0094C61.5627 58.0674 61.5049 58.1156 61.455 58.1532C61.405 58.1911 61.37 58.2165 61.3496 58.2298H62.1918V58.592H60.6983L60.698 58.5922Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7887 59.476C70.6515 59.476 70.5291 59.4569 70.4222 59.4185C70.3152 59.38 70.2255 59.3264 70.1534 59.2571C70.0812 59.1881 70.0294 59.1084 69.998 59.0187L70.4206 58.8082C70.4418 58.8647 70.4687 58.9149 70.5016 58.9583C70.5343 59.0017 70.5749 59.0352 70.6227 59.0582C70.6705 59.0814 70.7275 59.0929 70.7932 59.0929C70.8588 59.0929 70.9129 59.0796 70.9613 59.0527C71.0097 59.026 71.0473 58.9868 71.0743 58.9353C71.1009 58.8838 71.1145 58.8208 71.1145 58.746C71.1145 58.6905 71.1064 58.6419 71.0902 58.6006C71.074 58.5593 71.0518 58.524 71.0235 58.4952C70.9953 58.4665 70.9626 58.4453 70.9257 58.4317C70.8889 58.4181 70.8497 58.4113 70.8083 58.4113C70.7851 58.4113 70.7626 58.4134 70.7409 58.4173C70.7192 58.4212 70.698 58.4275 70.6773 58.4356C70.6567 58.4437 70.6371 58.4523 70.619 58.4612L70.3495 58.1689L70.9053 57.6873H70.0815V57.3223H71.4963V57.6873L70.9161 58.1673C70.9302 58.1592 70.9542 58.1524 70.988 58.1469C71.0217 58.1415 71.0539 58.1386 71.0842 58.1386C71.1428 58.1386 71.2019 58.1498 71.2615 58.1726C71.3211 58.1953 71.3763 58.2309 71.4272 58.2792C71.4782 58.3276 71.519 58.3904 71.5499 58.467C71.5807 58.5439 71.5962 58.6362 71.5962 58.7441C71.5962 58.8634 71.576 58.9682 71.5355 59.0592C71.4952 59.1502 71.438 59.2266 71.3642 59.2888C71.2905 59.351 71.2047 59.3976 71.1067 59.4289C71.0086 59.4603 70.9027 59.476 70.7885 59.476H70.7887Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8836_20107"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.432617,
    width: 91.1442,
    height: 124.724,
    rx: 4.79707,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankings);
export default __webpack_public_path__ + "static/media/rankings.766668f2f316c5a01a2c6aebc167a6c5.svg";
export { ForwardRef as ReactComponent };